import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { observer } from "mobx-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import Box from "../../Styled/Box";
import ActionBarPortal from "../ActionBar/ActionBarPortal";
import BottomDock from "../BottomDock/BottomDock";
import { useViewState } from "../Context";
import Loader from "../Loader";
import SlideUpFadeIn from "../Transitions/SlideUpFadeIn/SlideUpFadeIn";
import { BottomBar } from "./BottomBar";
import BottomLeftBar from "./BottomLeftBar/BottomLeftBar";
import { MapNavigation } from "./MapNavigation";
import MenuBar from "./MenuBar/MenuBar";
import { ProgressBar } from "./ProgressBar";
import { TerriaViewerWrapper } from "./TerriaViewerWrapper";
import Toast from "./Toast";
import { useTheme } from "styled-components";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Right-hand column that contains the map, controls that sit over the map and sometimes the bottom dock containing
 * the timeline and charts.
 */
export const MapColumn = observer(_ref => {
  let {
    customElements,
    animationDuration
  } = _ref;
  const viewState = useViewState();
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const loaderRef = useRef(null);
  return /*#__PURE__*/_jsx(_StyledBox, {
    column: true,
    fullWidth: true,
    fullHeight: true,
    children: /*#__PURE__*/_jsxs(Box, {
      column: true,
      fullWidth: true,
      fullHeight: true,
      children: [/*#__PURE__*/_jsx(_StyledDiv, {
        children: /*#__PURE__*/_jsx(ProgressBar, {})
      }), !viewState.hideMapUi && /*#__PURE__*/_jsxs(_StyledDiv2, {
        $_css: viewState.explorerPanelIsVisible && "opacity: 0.3;",
        children: [/*#__PURE__*/_jsx(MenuBar, {
          menuItems: customElements.menu,
          menuLeftItems: customElements.menuLeft,
          animationDuration: animationDuration,
          elementConfig: viewState.terria.elements.get("menu-bar")
        }), /*#__PURE__*/_jsx(MapNavigation, {
          viewState: viewState,
          navItems: customElements.nav,
          elementConfig: viewState.terria.elements.get("map-navigation")
        })]
      }), /*#__PURE__*/_jsx(_StyledBox2, {
        position: "absolute",
        fullWidth: true,
        fullHeight: true,
        children: /*#__PURE__*/_jsx(TerriaViewerWrapper, {})
      }), !viewState.hideMapUi && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ActionBarPortal, {
          show: viewState.isActionBarVisible
        }), /*#__PURE__*/_jsx(SlideUpFadeIn, {
          isVisible: viewState.isMapZooming,
          nodeRef: loaderRef,
          children: /*#__PURE__*/_jsx(Toast, {
            ref: loaderRef,
            children: /*#__PURE__*/_jsx(Loader, {
              message: t("toast.mapIsZooming"),
              textProps: {
                style: {
                  padding: "0 5px"
                }
              }
            })
          })
        }), /*#__PURE__*/_jsxs(_StyledDiv3, {
          $_css2: viewState.useSmallScreenInterface ? "0px" : viewState.isMapFullScreen ? "".concat(theme.workbenchMargin, "px") : "calc(".concat(theme.workbenchWidth, "px + 2 * ").concat(theme.workbenchMargin, "px)"),
          $_css3: viewState.useSmallScreenInterface ? "0px" : "calc(34px + 2 *".concat(theme.workbenchMargin, "px)"),
          $_css4: viewState.useSmallScreenInterface ? "0px" : "".concat(theme.workbenchMargin, "px"),
          children: [/*#__PURE__*/_jsx(BottomLeftBar, {}), /*#__PURE__*/_jsx(BottomDock, {
            terria: viewState.terria,
            viewState: viewState,
            elementConfig: viewState.terria.elements.get("bottom-dock")
          }), /*#__PURE__*/_jsx(BottomBar, {})]
        }), viewState.terria.configParameters.printDisclaimer && /*#__PURE__*/_jsx(_StyledA, {
          href: viewState.terria.configParameters.printDisclaimer.url,
          children: viewState.terria.configParameters.printDisclaimer.text
        })]
      })]
    })
  });
});
export default MapColumn;
var _StyledBox = _styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          * {\n            box-sizing: border-box;\n          }\n        "])));
var _StyledDiv = _styled2("div")({
  position: "absolute",
  top: "0",
  left: "0",
  zIndex: 1,
  width: "100%"
});
var _StyledDiv2 = _styled3("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                ", "\n              "])), p => p.$_css);
var _StyledBox2 = _styled4(Box)({
  top: "0",
  zIndex: 0
});
var _StyledDiv3 = _styled5("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                  position: absolute;\n                  margin-left: ", ";\n                  margin-right: ", ";\n                  bottom: ", ";\n                  left: 0;\n                  right: 0;\n                "])), p => p.$_css2, p => p.$_css3, p => p.$_css4);
var _StyledA = _styled6("a").withConfig({
  displayName: "MapColumn___StyledA",
  componentId: "sc-15vz2xn-0"
})(["display:none;@media print{display:block;width:100%;clear:both;}"]);